module.exports = __webpack_public_path__ + "static/media/help.07f2a02c.svg";